import { DatePicker, Form, Input, Select } from "antd";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { useNavigate, useParams } from "react-router";
import { DebounceSelect } from "../../../../component/DebounceSelect";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { dialog } from "../../../../helper/dialog";
import helper from "../../../../helper/helper";
import { CustomerUI } from "../../customer/entity/customer.model";
import { customerService } from "../../customer/service/customer.service";
import { PromotionUI } from "../../promotion/entity/promotion.model";
import { promotionService } from "../../promotion/service/promotion.service";
import { entityService } from "../../shared/service/entity.service";
import { Entity } from "../../shared/shared.model";
import { UserUI } from "../../user/entity/user.model";
import { RouteContext } from "../../user/screen/components/route.context";
import { userService } from "../../user/service/user.service";
import { PlanType, PlanUI } from "../entity/plan.model";
import { planService } from "../service/plan.service";

function EditPlan() {
  const { Option } = Select;

  let { planId } = useParams();
  let navigate = useNavigate();
  const { dispatch } = useContext(SpinContext);

  const [plan, setPlan] = useState<PlanUI>();
  const [brands, setBrands] = useState<Entity[]>([]);

  const { state } = useContext(RouteContext);

  useEffect(() => {
    if (planId) {
      dispatch({ type: spinActions.BLOCK });
      planService
        .getPlan(planId)
        .then((_plan) => {
          setPlan(_plan);
          dispatch({ type: spinActions.UNBLOCK });
        })
        .catch(() => {
          dispatch({ type: spinActions.UNBLOCK });
        });
    } else {
      setPlan({
        planType: undefined,
        startDate: moment(),
        endDate: moment(),
        amount: 0,
        name: "",
      });
    }

    entityService.getBrands().then((_brands) => {
      _brands.sort((a, b) => a.name.localeCompare(b.name));
      setBrands(_brands);
    });

    return () => {
      setBrands([]);
      setPlan({
        planType: undefined,
        startDate: moment(),
        endDate: moment(),
        amount: 0,
        name: "",
      });
    };
  }, [planId]);

  function onTypeChange(value: PlanType) {
    setPlan({ ...plan!, planType: value });
  }

  const onFinish = async (_plan: PlanUI) => {
    if (state.routeId.length > 0) {
      if (_plan.planType === PlanType.BRAND.valueOf()) {
        let date = moment().set("month", _plan.month! - 1);

        _plan.startDate = date.clone().startOf("month");
        _plan.endDate = date.clone().endOf("month");
      }

      if (_plan.planType === PlanType.CUSTOMER.valueOf()) {
        _plan.customerId = _plan.customer?.uuid;
        _plan.name = _plan.customer!.name;
        _plan.companyCode = _plan.customer?.companyCode;
      }

      _plan.routeId = state.routeId;

      if (plan?.uuid) {
        _plan.uuid = plan.uuid;
        await planService.updatePlan(_plan);
      } else {
        await planService.addPlan(_plan);
      }

      dialog.success(
        `Төлөвлөгөө амжилттай ${!plan?.uuid ? "нэмэгдлээ" : "шинэчлэгдлээ"}.`
      );

      navigate("/plans");
    } else {
      dialog.error("Route сонгоно уу.");
    }
  };

  const TypeDatePicker = () => {
    if (plan?.planType === PlanType.BRAND) {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Сар</label>
              <Form.Item
                name="month"
                rules={[
                  {
                    required: true,
                    message: "Сарыг сонгоно уу.",
                  },
                ]}
              >
                <Select
                  placeholder={"Сар сонгох"}
                  disabled={!helper.hasRoles(["plan-full"])}
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
                    .filter((x) => x > moment().month())
                    .map((value) => (
                      <Option key={value} value={value}>
                        {value} - р сар
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Брэнд</label>
              <Form.Item
                name="brandId"
                rules={[
                  {
                    required: true,
                    message: "Брэндийг сонгоно уу.",
                  },
                ]}
              >
                <Select
                  disabled={!helper.hasRoles(["plan-full"])}
                  placeholder="Брэнд сонгох"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option!.children as unknown as string)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {brands.map((brand) => (
                    <Option value={brand.uuid}>{brand.name}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>
        </div>
      );
    } else if (plan?.planType === PlanType.PROMOTION) {
      return (
        <>
          <div className="form-group">
            <label>Промошн</label>
            <Form.Item
              name="promotion"
              rules={[
                {
                  required: true,
                  message: "Промошныг оруулна уу.",
                },
              ]}
            >
              <DebounceSelect<PromotionUI>
                showSearch
                disabled={!helper.hasRoles(["plan-full"])}
                allowClear
                placeholder="Хайх"
                fetchOptions={async (name: string) => {
                  let options = await promotionService.getPromotions({
                    name,
                    page: 1,
                    pageSize: 1000,
                    routeId: state.routeId,
                  });

                  return options.content;
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </div>
        </>
      );
    } else if (plan?.planType === PlanType.CUSTOMER) {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Эхлэх огноо</label>
              <Form.Item
                name="startDate"
                rules={[
                  {
                    required: true,
                    message: "Эхлэх огноог оруулна уу.",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD"}
                  className="w-100"
                  disabledDate={(d) => d.isBefore(moment().add(-1, "d"))}
                />
              </Form.Item>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Дуусах огноо</label>
              <Form.Item
                name="endDate"
                rules={[
                  {
                    required: true,
                    message: "Дуусах огноог оруулна уу.",
                  },
                ]}
              >
                <DatePicker
                  disabledDate={(d) => d.isBefore(moment().add(-1, "d"))}
                  format={"YYYY-MM-DD"}
                  className="w-100"
                />
              </Form.Item>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Харилцагч</label>
              <Form.Item
                name="customer"
                rules={[
                  {
                    required: true,
                    message: "Харилцагчийг сонгоно уу.",
                  },
                ]}
              >
                <DebounceSelect<CustomerUI>
                  showSearch
                  allowClear
                  disabled={!helper.hasRoles(["plan-full"])}
                  placeholder="Харилцагчийг сонгоно уу"
                  fetchOptions={async (value) => {
                    let _page = await customerService.getCustomers({
                      name: value,
                      page: 1,
                      pageSize: 10,
                      routeId: state.routeId,
                    });

                    return _page.results;
                  }}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <MPageHeader crumbs={["Төлөвлөгөө"]} />
      <div className="content">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title">Төлөвлөгөөний мэдээлэл</h6>
          </div>
          <div className="card-body">
            {plan && (
              <fieldset disabled={!helper.hasRoles(["plan-full"])}>
                <Form initialValues={plan} onFinish={onFinish}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Хэрэглэгчийн нэр</label>
                        <Form.Item
                          name="user"
                          rules={[
                            {
                              required: true,
                              message: "Хэрэглэгчийн нэрийг оруулна уу.",
                            },
                          ]}
                        >
                          <DebounceSelect<UserUI>
                            showSearch
                            disabled={!helper.hasRoles(["plan-full"])}
                            placeholder="Хайх"
                            fetchOptions={(search) => {
                              return userService.getUsers(
                                search,
                                state.routeId
                              );
                            }}
                            style={{ width: "100%" }}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Нэр</label>
                        <Form.Item
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "Нэрийг оруулна уу.",
                            },
                          ]}
                        >
                          <Input
                            readOnly={plan.planType === PlanType.CUSTOMER}
                            placeholder="Төлөвлөгөөний нэрийг оруулна уу"
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Төрөл сонгох</label>
                        <Form.Item
                          name="planType"
                          rules={[
                            {
                              required: true,
                              message: "Төрлийг сонгоно уу.",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Төрөл сонгох"
                            onChange={onTypeChange}
                            disabled={!helper.hasRoles(["plan-full"])}
                          >
                            <Option value={PlanType.CUSTOMER}>Харилцагч</Option>
                            <Option value={PlanType.BRAND}>Брэнд</Option>
                            <Option value={PlanType.PROMOTION}>Промошн</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Мөнгөн дүн</label>
                        <Form.Item
                          name="amount"
                          rules={[
                            {
                              required: true,
                              message: "Төлөвлөгөөний дүнийг оруулна уу.",
                            },
                          ]}
                          trigger="onValueChange"
                        >
                          <CurrencyInput
                            className="ant-input"
                            placeholder="Мөнгөн дүнгээ оруулна уу"
                            prefix="₮"
                            decimalScale={2}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {TypeDatePicker()}
                  <div className="text-right">
                    <button type="submit" className="btn btn-primary">
                      Хадгалах <i className="icon-floppy-disk ml-2" />
                    </button>
                  </div>
                </Form>
              </fieldset>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EditPlan;
